// Dive Bomb visibility geometry shared by the action bar and Core Attacks.
// Keep the ground tolerance aligned with check_and_apply_falling.php: a non-hovering
// creature whose support plane is at or below 2 ft is treated as grounded.

export const DIVE_BOMB_ATTACK_ABILITY_ID = '82786050-BC9F-A0A7-C882-9A8394575384';
export const HOVERING_SPEED_TYPE_ID = 'AE7D4EB3-DC36-BD47-978F-1DBCFE2B616A';

const GROUNDED_SUPPORT_TOLERANCE_FT = 2;

/**
 * Whether Dive Bomb should be discoverable from the caster's current geometry.
 * Missing/invalid physics height fails closed: base size is not a safe substitute
 * because portrait aspect ratio can make the rendered/physical height differ widely.
 */
export function canShowDiveBomb(
    zCenter: number,
    physicsHeight: number,
    preferredSpeedType: unknown,
): boolean {
    if (!Number.isFinite(zCenter) || !Number.isFinite(physicsHeight) || physicsHeight <= 0) {
        return false;
    }

    const supportZ = zCenter - physicsHeight / 2;
    const isHovering = String(preferredSpeedType ?? '').toUpperCase() === HOVERING_SPEED_TYPE_ID;
    return supportZ > GROUNDED_SUPPORT_TOLERANCE_FT && !isHovering;
}
